/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


(function(){
  
  document.addEventListener('product:added', function(e) {
    const voltageModal = document.querySelector('.modal--voltage')
    const serialNumberModal = document.querySelector('.modal--serial-number')

    let voltageInit = false
    let serialNumberInit = false

    function closeVoltage(e) {
      e.preventDefault()
      voltageModal.setAttribute('aria-hidden', 'true')
    }

    function closeSerialNumber(e) {
      e.preventDefault()
      serialNumberModal.setAttribute('aria-hidden', 'true')
    }

    if (e.detail.options && e.detail.options.includes('Voltage') && voltageModal) {
      console.log('Has Voltage')
      voltageModal.setAttribute('aria-hidden', 'false')

      if (!voltageInit) {
        voltageModal.addEventListener('click', closeVoltage)
        voltageModal.querySelectorAll('.modal--voltage, .modal--voltage [data-action="close-popup"]').forEach(x => {
          x.addEventListener('click', closeVoltage)
        })
        voltageInit = true
      }
    }

    if (e.detail.options && e.detail.options.includes('Serial Number') && serialNumberModal) {
      console.log('Has Serial Number')
      serialNumberModal.setAttribute('aria-hidden', 'false')

      if (!serialNumberInit) {
        serialNumberModal.addEventListener('click', closeSerialNumber)
        serialNumberModal.querySelectorAll('.modal--serial-number, .modal--serial-number [data-action="close-popup"]').forEach(x => {
          x.addEventListener('click', closeSerialNumber)
        })
        serialNumberInit = true
      }
    }


  })
})()
